import EdicationIcon from "@mui/icons-material/MenuBook";
import { resources as Specialities } from "./Specialities";
import { resources as SpecialitiesGroups } from "./SpecialitiesGroups";
import { resources as Disciplines } from "./Disciplines";
import { resources as ElectiveCoursesMF } from "./ElectiveCoursesMF";
import { resources as Curriculums } from "./Curriculum";
import { resources as CurriculumDisciplinePrices } from "./Curriculum/DisciplinePrices";
import { resources as Practices } from "./Practices";
import { resources as Internships } from "./Internships";
import { resources as StateExams } from "./StateExams";
import { resources as AnnualFees } from "./Specialities/AnnualFees";
import { resources as Camps } from "./Camps";
import { resources as ForeignLanguages } from "./ForeignLanguages";
import { resources as ActivityForeignLanguages } from "./ActivityForeignLanguages";
import { resources as Sports } from "./Sports";
import { resources as ManageCapacity } from "./ActivityForeignLanguages/ManageCapacity";
import { resources as EntryTests } from "./ActivityForeignLanguages/EntryTests";
import { tenants } from "utils/tenants";
//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <EdicationIcon />,
  name: "Образование",
  title: "Образование",
  subMenu: [
    Specialities,
    SpecialitiesGroups,
    Disciplines,
    ElectiveCoursesMF,
    Curriculums,
    CurriculumDisciplinePrices,
    Practices,
    Internships,
    StateExams,
    Camps,
    AnnualFees,
    ForeignLanguages,
    ActivityForeignLanguages,
    Sports,
    ManageCapacity,
    EntryTests,
  ],
};
